<script>
export default {
    name: "PatientBillItemModal",

    props: {
        showModal: Boolean,
        patient: Object,
    },

    computed: {
      
      grandTotal() {

          if(!this.patient.billItems.length) return 0;

          const billItemsFiltered = this.patient.billItems.filter(billI => billI.total);

          if(!billItemsFiltered.length) return 0;

          const billItems = billItemsFiltered.map(billI => parseFloat(billI.grandTotal));

          return billItems.reduce((gTotal, accTotal) => gTotal + accTotal);
      },
    },

    methods: {

        printUnpostedBillsDetails() {

            window.open(`/reports/accounts-finance/unposted-bills-details/print?patientID=${this.patient.patientID}`,
             '_blank', `ReportPrint`, "menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes");
        },
    },
}
</script>
<template>
<tail-modal :show="showModal" dimension="md:w-2/3 sm:11/12">
  <template v-slot:title>
    <h5 class="font-bold text-base">Patient Bill Items</h5>
  </template>
  <template v-slot:modal-body>
    <div class="w-full overflow-auto">
        <table class="table table-bordered table-hover text-sm">
            <thead class="bg-blue-500 text-white text-sm">
                <tr>
                    <th class="p-tiny">#</th>
                    <th class="p-tiny">Date</th>
                    <th class="p-tiny">User</th>
                    <th class="p-tiny">Item</th>
                    <th class="p-tiny">Description</th>
                    <th class="p-tiny">Qty</th>
                    <th class="p-tiny">Price</th>
                    <th class="p-tiny">Discount</th>
                    <th class="p-tiny">Tax</th>
                    <th class="p-tiny">L.Total</th>
                    <th class="p-tiny">Net Total</th>
                </tr>
            </thead>
            <tbody class="text-xs">
                <tr v-for="(billItem, idx) in patient.billItems" :key="idx">
                    <td class="p-tiny">{{ billItem.invoiceDetailID }}</td>
                    <td class="p-tiny">{{ billItem.txnDate | dateFormat }}</td>
                    <td class="p-tiny">{{ billItem.userName }}</td>
                    <td class="p-tiny">{{ billItem.itemName }}</td>
                    <td class="p-tiny">{{ billItem.description }}</td>
                    <td class="p-tiny">{{ billItem.quantity }}</td>
                    <td class="p-tiny">{{ billItem.charge | numberFormat }}</td>
                    <td class="p-tiny">{{ billItem.discount | numberFormat }}</td>
                    <td class="p-tiny">{{ billItem.tax | numberFormat }}</td>
                    <td class="p-tiny">{{ billItem.lineTotal | numberFormat }}</td>
                    <td class="p-tiny">{{ billItem.grandTotal | numberFormat }}</td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <th class="p-tiny"></th>
                    <th class="p-tiny"></th>
                    <th class="p-tiny"></th>
                    <th class="p-tiny"></th>
                    <th class="p-tiny"></th>
                    <th class="p-tiny"></th>
                    <th class="p-tiny"></th>
                    <th class="p-tiny"></th>
                    <th class="p-tiny"></th>
                    <th class="p-tiny">Total</th>
                    <th class="p-tiny">{{ grandTotal | numberFormat }}</th>
                </tr> 
            </tfoot>
        </table>
    </div>
  </template>
  <template v-slot:modal-footer>
    <button 
      class="btn-danger btn-sm text-xs mr-8 rounded" 
      @click="$emit(`closeModal`)">
        <i class="fa fa-times"></i> Cancel</button>
    <button 
      class="btn-sm btn-primary text-xs rounded" 
      @click.prevent="printUnpostedBillsDetails">
        <i class="fa fa-print"></i> Print</button>
  </template>
</tail-modal>
</template>